module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "flat": "",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("person")])], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pt-0"
  }, [_c('v-layout', {
    staticClass: "pa-3 mb-2 grey lighten-3 black--text",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$store.state.user.user.name))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_vm._v(_vm._s(_vm.$store.state.user.user.email))])], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "to": {
        name: 'Logout'
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("exit_to_app")])], 1), _vm._v(" "), _c('v-list-tile-title', {
    staticClass: " "
  }, [_vm._v("Sign Out")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e61a1f2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheHeader/TheHeaderMenuProfile.vue
// module id = 357
// module chunks = 0